module.exports = __webpack_public_path__ + "assets/3d6f49cdd2c0f57680885af7c9028e55.mp3";